import { isPWA } from "@/helpers/generalHelper";
import { ActionTypes } from "../constants/action-types";

//setting PWA state
let pwa = false;
let guestVisit;
let visited;
let wc_journey = {}
let first_visit = false;

if (typeof window !== "undefined") {
  pwa = isPWA()
}
if (typeof window !== "undefined") {
  if (typeof localStorage.getItem("firstVisit") === "undefined" || localStorage.getItem("firstVisit") === "false") {
    guestVisit = false;
  } else {
    guestVisit = true;
  }
}

if (typeof window !== "undefined") { 
    const storedVisits = localStorage.getItem('visited');
    if (storedVisits) {
      visited = true;
    }
    else {
      visited = false;
    }

    // To show welcome journey for first time visit
    if (localStorage.getItem("firstVisit") !== null || localStorage.getItem("firstVisit") == "false") {
      first_visit = false
    } else {
      first_visit = true;
    }

    // Welcome journey states
    wc_journey = {
      addWCOverlay: first_visit ? true : false,
      isSkipped: false,
      currentStepNo: first_visit ? 1 : 6,
      totalSteps: 5,
    };
}

const initialState = {
  is_PWA: pwa,
  firstVisit: first_visit,
  is_guest: guestVisit,
  is_visited: visited,
  welcome_journey: wc_journey,
  previous_nav: '',
  pwa_loader:false,
  pwa_link_tag_click:false,
};

export const pwaReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case ActionTypes.IS_PWA:
      return {
        ...state,
        is_PWA : payload
      }
    case ActionTypes.IS_GUEST:
      return {
        ...state,
        is_guest: payload
      };
    case ActionTypes.IS_VISITED:
      return {
        ...state,
        is_visited: payload
      };
    case ActionTypes.WELCOME_STEP:
      return {
        ...state,
        step: payload
      };
    case ActionTypes.WELCOME_JOURNEY:
      return {
        ...state,
        welcome_journey: payload
      };
    case ActionTypes.PREVIOUS_NAV:
      return {
        ...state,
        previous_nav: payload
      };
    case ActionTypes.PWA_LOADER:
      return {
        ...state,
        pwa_loader: payload
      };
    case ActionTypes.PWA_LINK_TAG_CLICK:
      return {
        ...state,
        pwa_link_tag_click: payload
      };
    default:
      return state;
  }
};
